import { OrthographicCamera } from 'three'
import VaultHero from './VaultHero.js'

export default class Camera {
    constructor(_options) {
        // Options
        this.experience = new VaultHero()
        this.config = this.experience.config
        this.debug = this.experience.debug
        this.time = this.experience.time
        this.sizes = this.experience.sizes
        this.targetElement = this.experience.targetElement
        this.scene = this.experience.scene

        this.setInstance()
    }

    setInstance() {
        // Set up
        this.instance = new OrthographicCamera(-this.sizes.aspectRatio, this.sizes.aspectRatio, 1, -1, 0.1, 10);

        this.instance.position.z = 5;
        this.instance.updateMatrixWorld()
        this.scene.add(this.instance)
    }

    resize() {
        this.instance.left = -this.sizes.aspectRatio
        this.instance.right = this.sizes.aspectRatio
        this.instance.updateProjectionMatrix()
    }
}
